import React from 'react';
import Button from '@mui/material/Button';
import { ReactComponent as ChatBotStoppedIcon } from './icons/chatbot_settings_red_dot.svg';
import { cv } from '../themeVars';

// Sits under the web-widget holding message ("I've passed your question along to
// our team") in the thread. Agents read the thread, not the header: the bubble
// itself renders like any other chatbot reply, so this line says what that message
// meant -- the bot stepped back -- and, while the bot is still quiet, carries the
// resume action so nobody has to find the chatbot panel. Same icon as the header
// dot, so red means the same thing in both places.
const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    margin: '6px 0 2px 0',
    padding: '7px 12px',
    border: `1px dashed ${cv('danger-border', '#f3b6b2')}`,
    borderRadius: 8,
    background: cv('danger-tint', '#fff7f6'),
    fontSize: '0.8rem',
    lineHeight: 1.4,
    color: cv('text', '#4b3b3a'),
  },
  icon: { width: 18, height: 18, flexShrink: 0, display: 'block' },
  headline: { fontWeight: 600, color: cv('danger-text', '#a8201a') },
  resume: { marginLeft: 'auto', fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.04em', padding: '2px 9px', minWidth: 0, background: cv('surface', '#fff') },
};

export default function ChatbotHandoffMarker({ quietSentence, onResume, resuming }) {
  return (
    <div style={styles.root} data-testid="chatbot-handoff-marker">
      <ChatBotStoppedIcon style={styles.icon} aria-hidden="true" />
      <span>
        <span style={styles.headline}>Handed off to your team.</span>
        {quietSentence ? ` ${quietSentence}` : ''}
      </span>
      {quietSentence && onResume ? (
        <Button size="small" variant="outlined" color="primary" style={styles.resume}
                onClick={onResume} disabled={!!resuming}>
          Resume chatbot
        </Button>
      ) : null}
    </div>
  );
}
